import { updateField } from 'vuex-map-fields'

function normalizeAmount(amount) {
  return Math.max(0, parseInt(amount, 10) || 0);
}

function syncDistributedLuggageTotals(state) {
  ['luggageSmall', 'luggageLarge'].forEach(bagType => {
    if (!state.cart[bagType] || !Array.isArray(state.cart.people)) {
      return;
    }

    state.cart[bagType].amount = state.cart.people.reduce((total, person) => {
      return total + normalizeAmount(person[bagType]);
    }, 0);
  });
}

export const mutations = {
  setPuroadLevelValue (state, value) {
    state.puroadLevel.value = value;
  },
  setServiceSelection(state, payload) {
    state.cart.serviceUdrejse = Boolean(payload.serviceUdrejse);
    state.cart.serviceHjemrejse = Boolean(payload.serviceHjemrejse);
    state.cart.includeHome = Boolean(payload.serviceHjemrejse);
  },
  enableErrorDisplays(state) {
    state.shouldDisplayErrors = true;
  },
  disableErrorDisplays(state) {
    state.shouldDisplayErrors = false
  },
  updateField,
  incrementProduct (state, prop) {
    state.cart[prop].amount++
  },
  setProductAmount (state, { prop, amount }) {
    const normalizedAmount = normalizeAmount(amount);
    if (state.cart[prop]) {
      state.cart[prop].amount = normalizedAmount;
    }
  },
  decrementProduct (state, prop) {
    if (state.cart[prop].amount > 0) {
      state.cart[prop].amount--
    }
  },
  setPeople(state, amount) {
    state.cart.people = [];
    for (let i = 1; i <= amount; i++) {
      state.cart.people.push({
        id: i,
        firstName: '',
        lastName: '',
        luggageSmall: 0,
        luggageLarge: 0
      })
    }
    // Set the first person as responsible by default
    if (amount > 0) {
      state.cart.responsiblePersonId = 1;
    }
  },
  incrementPeople (state) {
    let id = 0;
    if (state.cart.people.length !== 0) {
      id = state.cart.people[state.cart.people.length - 1].id + 1;
    } else {
      id = 1;
    }

    state.cart.people.push({
      id: id,
      firstName: '',
      lastName: '',
      luggageSmall: 0,
      luggageLarge: 0
    })

    // If this is the first person, make them responsible
    if (state.cart.people.length === 1) {
      state.cart.responsiblePersonId = id;
    }
  },
  decrementPeople (state) {
    if (state.cart.people.length > 0) {
      const lastPerson = state.cart.people[state.cart.people.length - 1];
      
      // If the person being removed was responsible, reassign to the previous person
      if (state.cart.responsiblePersonId === lastPerson.id && state.cart.people.length > 1) {
        state.cart.responsiblePersonId = state.cart.people[state.cart.people.length - 2].id;
      }
      
      state.cart.people.pop();
      
      // If no people left, reset responsible person
      if (state.cart.people.length === 0) {
        state.cart.responsiblePersonId = null;
      }
    }
  },
  setResponsiblePerson (state, personId) {
    state.cart.responsiblePersonId = personId
  },
  removePerson(state, id) {
    const removablePerson = state.cart.people.find(person => person.id === id);
    if (!removablePerson) {
      return;
    }

    // Check if the person being removed was responsible
    const wasResponsible = state.cart.responsiblePersonId === id;

    // Removing person
    state.cart.people = state.cart.people.filter(person => person.id !== id)

    // If the removed person was responsible, assign the first remaining person
    if (wasResponsible && state.cart.people.length > 0) {
      state.cart.responsiblePersonId = state.cart.people[0].id;
    }

    syncDistributedLuggageTotals(state);
  },
  distributeLuggage(state, {id, type, to}) {
    let person = state.cart.people.find(person => person.id === id)
    if (!person || !state.cart[type]) {
      return;
    }

    if (to === 'person') {
      person[type]++
    } else {
      if(person[type] > 0) {
        person[type]--
      }
    }

    syncDistributedLuggageTotals(state);
  },
  specificDistributedLuggage(state, {id, type, amount}) {
    let person = state.cart.people.find(person => person.id === id);
    if (!person || !state.cart[type]) {
      return;
    }

    person[type] = normalizeAmount(amount);
    syncDistributedLuggageTotals(state);
  },
  validateTravelTotal (state, value) {
    if (value) {
      state.contact.zip = ''
    }
  },
  setCoupon(state, payload) {
    state.payment.couponType = ''
    state.payment.couponValue = 0
    state.payment.couponExpirydate = ''
    state.payment.couponIncludeUdrejse = true
    state.payment.couponIncludeHjemrejse = true
    state.payment.couponWasExpired = false
    state.payment.couponError = false
    state.payment.couponIncludeUdrejse = true
    state.payment.couponIncludeHjemrejse = true

    if (payload) {
      state.payment.couponType = payload.type
      state.payment.couponValue = parseInt(payload.value)
      if (payload.include_udrejse !== undefined) state.payment.couponIncludeUdrejse = payload.include_udrejse;
      if (payload.include_hjemrejse !== undefined) state.payment.couponIncludeHjemrejse = payload.include_hjemrejse;

      if (typeof payload.include_udrejse !== 'undefined') {
        state.payment.couponIncludeUdrejse = Boolean(payload.include_udrejse)
      }
      if (typeof payload.include_hjemrejse !== 'undefined') {
        state.payment.couponIncludeHjemrejse = Boolean(payload.include_hjemrejse)
      }
      if (payload.type === 'Value card') {
        state.payment.couponExpirydate = payload.expirydate
        if (!payload.is_active) {
          state.payment.couponError = true
          state.payment.couponWasExpired = true
          state.payment.couponValue = 0
        }
      } else {
        if (!payload.is_active) {
          state.payment.couponWasExpired = true
          state.payment.couponValue = 0
        }
      }
    } else {
      state.payment.couponError = true
      state.payment.couponValue = 0
    }
  },
  setPricingLoading(state, payload) {
    state.pricing.isLoading = Boolean(payload);
  },
  setPricingQuote(state, payload) {
    state.pricing.quoteId = payload.quoteId || '';
    state.pricing.quoteSignature = payload.quoteSignature || '';
    state.pricing.inputHash = payload.inputHash || '';
    state.pricing.expiresAt = payload.expiresAt || '';
    state.pricing.currency = payload.currency || 'DKK';
    state.pricing.rulesVersion = payload.rulesVersion || '';
    state.pricing.priceBreakdown = payload.priceBreakdown || null;
    state.pricing.lastRequestId = payload.requestId || '';
    state.pricing.lastError = '';
    if (state.pricing.priceBreakdown && typeof state.pricing.priceBreakdown.totalPreCoupon !== 'undefined') {
      state.payment.totalPreCoupon = state.pricing.priceBreakdown.totalPreCoupon;
    }
    if (state.pricing.priceBreakdown && typeof state.pricing.priceBreakdown.couponReduction !== 'undefined') {
      state.payment.couponValueCU = state.pricing.priceBreakdown.couponReduction;
    }
  },
  setPricingError(state, message) {
    state.pricing.lastError = message || '';
  },
  resetPricingQuote(state) {
    state.pricing.quoteId = '';
    state.pricing.quoteSignature = '';
    state.pricing.inputHash = '';
    state.pricing.expiresAt = '';
    state.pricing.rulesVersion = '';
    state.pricing.priceBreakdown = null;
    state.pricing.lastRequestId = '';
    state.pricing.lastError = '';
  },
  updateTransitStops(state, stops) {
    state.bookingHome.transitStops = stops;
  }
}
